import PropTypes from 'prop-types';
import React from 'react';

/** **IMPORTANT:** these must line up with `filterAndSort.sortOptions` */
export const sortOrderSentences = {
  'lastUpdate.newest': 'last updated (newest to oldest)',
  'lastUpdate.oldest': 'last updated (oldest to newest)',
};

/** @typedef {keyof sortOrderSentences} sortOption */

/**
 * @param {{
 * filtersCount?: number,
 * sortOrder: sortOption
 * pageStart?: number,
 * pageEnd?: number,
 * total: number,
 * query: string,
 * }} props
 */
export default function SearchDescription({
  filtersCount,
  sortOrder,
  pageEnd,
  pageStart,
  total,
  query,
}) {
  const displayCount = total ? `${pageStart}-${pageEnd} of ${total}` : 'no';
  const queryPart = query
    ? ` for "${query}${total && !filtersCount ? ',' : ''}${
        total || filtersCount ? '"' : ''
      }`
    : '';

  const filtersPart =
    filtersCount && filtersCount > 0
      ? ` with ${filtersCount} filter${filtersCount === 1 ? '' : 's'} applied`
      : '';

  const sortOrderPart = total
    ? `${query && !filtersCount ? '' : ','} sorted by ${
        sortOrderSentences[sortOrder]
      }`
    : '';

  const closingPeriod = query && !total && !filtersCount ? '."' : '.';

  return (
    <div id="search-description" role="status">
      <h3 className="vads-u-font-family--sans vads-u-font-size--md">
        Showing {displayCount} results
        {queryPart}
        {filtersPart}
        {sortOrderPart}
        {closingPeriod}
      </h3>
      {!total && (
        <>
          <p data-testid="no-results-suggestion">
            Search 1 of these 3 things to get more results:
          </p>
          <ul>
            <li>Reference number</li>
            <li>Category name</li>
            <li>Original question</li>
          </ul>
        </>
      )}
    </div>
  );
}

SearchDescription.propTypes = {
  query: PropTypes.string.isRequired,
  sortOrder: PropTypes.oneOf(Object.keys(sortOrderSentences)).isRequired,
  total: PropTypes.number.isRequired,
  filtersCount: PropTypes.number,
  pageEnd: PropTypes.number,
  pageStart: PropTypes.number,
};
